import { Box, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { useBacktrack } from 'components/common/withBacktrack';
import { Spinner } from 'components/core';
import {
  useEditOrganization,
  withEditOrganization,
} from 'components/dataCreationForms/organization/withEditOrganization';
import { WithInputForm } from 'components/dataCreationForms/withInputForm';
import { FormBottonButtons } from 'components/general/ButtonsPanel/ButtonsPanel';
import { OrganizationForm } from 'components/organization/form';
import { useFormCleanupOnUnmount } from 'presentation/dialogForms/dialogFormsHooks';
import React from 'react';
import { ReactElement, useCallback } from 'react';
import {  FormattedMessage , formatTranslation } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import { useIntl } from 'react-intl';

function EditOrganizationContainer(): ReactElement {
  const {
    submitForm,
    isPosting,
    existingValues,
    releaseSubmitEvent,
    SUBMIT_EVENT_TYPE,
    handleFormValidation,
    validate,
    formName,
  } = useEditOrganization();
  useFormCleanupOnUnmount(formName);
  const intl = useIntl();

  const { back } = useBacktrack();
  const onCancel = useCallback(() => {
    back();
  }, [back]);

  if (!existingValues) {
    return (
      <Spinner
        reason={`EditOrganizationContainer: Waiting for existing values: ${existingValues}`}
      />
    );
  }

  return (
    <WithInputForm
      values={existingValues}
      errors={{}}
      handleFormValidation={handleFormValidation}
      handleFieldValidation={validate}
      onSubmit={submitForm}
      eventType={SUBMIT_EVENT_TYPE}
      dispatchSubmit={releaseSubmitEvent}
      formName={formName}
    >
      <Typography sx={{ m: 3 }} variant='h1' margin='dense'>
        {formatTranslation(intl, ProjectSetupTranslationKeys.editOrganization)}
      </Typography>
      <Divider />
      <Box sx={{ p: 3, mb: 8 }}>
        <OrganizationForm isDialog={false} />
      </Box>
      <FormBottonButtons
        isPosting={isPosting}
        onSubmit={releaseSubmitEvent}
        onCancel={onCancel}
      />
    </WithInputForm>
  );
}

export const MemoEditOrganizationWizardContainer = withEditOrganization(
  React.memo(EditOrganizationContainer)
);
